import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AppRoutes, MODAL_TOKEN, ModalProvider, NotificationsRoutes } from '@core';
import { Router } from '@angular/router';

@Component({
  selector: 'lib-push-alerts',
  templateUrl: './push-alerts.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class PushAlertsComponent {
  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly router: Router = inject(Router);

  handleAction(): void {
    this.modalProvider.dismissAllStoredModals();
    this.router.navigateByUrl(`${AppRoutes.NOTIFICATIONS}/${NotificationsRoutes.ALERTS}`);
  }

  closeModal(): void {
    this.modalProvider.dismissAllStoredModals();
  }
}
